import { HStack, IconStatus, Text, VStack } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { TransferStatusHistoryItem } from '../../../../../../store/customerDetail/SecuritiesTransfer/types';
import {
  ColoredSkeleton,
  TextSkeleton,
} from '../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

const TimelineItem: React.FC<TransferStatusHistoryItem> = ({
  id,
  label,
  dateTime,
  isActive,
  description,
  statusIcon,
}) => {
  const bottomTexts = [description, dateTime].filter(Boolean);

  return (
    <HStack space="inline.xs" alignItems="flex-start">
      <IconStatus
        testId={`status-timeline-icon-${id}`}
        icon={statusIcon.icon}
        bgColor={statusIcon.bgColor}
        color={statusIcon.color}
        size={statusIcon.size || 'xxs'}
      />

      <VStack flex={1} space="stack.quarck">
        <Text variant="semibold" color={isActive ? 'neutral.black' : 'neutral.light'}>
          {label}
        </Text>

        <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
          {bottomTexts.map((text, index) => (
            <Text
              key={`${id}-text-${index}`}
              {...(index === 1 ? { variant: 'semibold', flexShrink: 0 } : {})}
              color={isActive ? 'neutral.darkest' : 'neutral.light'}
              fontSize="sm">
              {text}
            </Text>
          ))}
        </HStack>
      </VStack>
    </HStack>
  );
};

export const TimelineItemMemo = React.memo(TimelineItem);

export const TimelineItemLoading: React.FC = () => {
  return (
    <HStack space="inline.xs" alignItems="flex-start">
      <ColoredSkeleton width="inline.xxs" height="stack.xxs" borderRadius={BoxRadius.circular} />

      <VStack flex={1} space="stack.quarck">
        <TextSkeleton w="20%" />
        <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
          <TextSkeleton w="1/3" />
          <TextSkeleton w="inline.sm" />
        </HStack>
      </VStack>
    </HStack>
  );
};
